/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getTermByKey<TTerms extends { [K: string]: any }>(
	terms: TTerms,
	key: string,
	defaultKey: string
): TTerms[keyof TTerms] {
	if (terms[key] !== undefined) {
		return terms[key];
	} else {
		return terms[defaultKey];
	}
}
